import { defineComponent, h, computed, inject } from 'vue';
import XEUtils from 'xe-utils';
import { getFuncText } from '../../tools/utils';
import GlobalConfig from '../../v-x-e-table/src/conf';
import { useSize } from '../../hooks/size';
export default defineComponent({
    name: 'VxeRadio',
    props: {
        modelValue: [String, Number, Boolean],
        label: { type: [String, Number, Boolean], default: null },
        title: [String, Number],
        content: [String, Number],
        disabled: Boolean,
        name: String,
        strict: { type: Boolean, default: function () { return GlobalConfig.radio.strict; } },
        size: { type: String, default: function () { return GlobalConfig.radio.size || GlobalConfig.size; } }
    },
    emits: [
        'update:modelValue',
        'change'
    ],
    setup: function (props, context) {
        var slots = context.slots, emit = context.emit;
        var $xeform = inject('$xeform', null);
        var $xeformiteminfo = inject('$xeformiteminfo', null);
        var xID = XEUtils.uniqueId();
        var $xeradio = {
            xID: xID,
            props: props,
            context: context
        };
        var computeSize = useSize(props);
        var $xeradiogroup = inject('$xeradiogroup', null);
        var radioMethods = {};
        var computeDisabled = computed(function () {
            return props.disabled || ($xeradiogroup && $xeradiogroup.props.disabled);
        });
        var computeName = computed(function () {
            return $xeradiogroup ? $xeradiogroup.name : props.name;
        });
        var computeStrict = computed(function () {
            return $xeradiogroup ? $xeradiogroup.props.strict : props.strict;
        });
        var computeChecked = computed(function () {
            var modelValue = props.modelValue, label = props.label;
            return $xeradiogroup ? $xeradiogroup.props.modelValue === label : modelValue === label;
        });
        var handleValue = function (label, evnt) {
            if ($xeradiogroup) {
                $xeradiogroup.handleChecked({ label: label }, evnt);
            }
            else {
                emit('update:modelValue', label);
                radioMethods.dispatchEvent('change', { label: label }, evnt);
                // 自动更新校验状态
                if ($xeform && $xeformiteminfo) {
                    $xeform.triggerItemEvent(evnt, $xeformiteminfo.itemConfig.field, label);
                }
            }
        };
        var changeEvent = function (evnt) {
            var isDisabled = computeDisabled.value;
            if (!isDisabled) {
                handleValue(props.label, evnt);
            }
        };
        var clickEvent = function (evnt) {
            var isDisabled = computeDisabled.value;
            var isStrict = computeStrict.value;
            if (!isDisabled && !isStrict) {
                if (props.label === ($xeradiogroup ? $xeradiogroup.props.modelValue : props.modelValue)) {
                    handleValue(null, evnt);
                }
            }
        };
        radioMethods = {
            dispatchEvent: function (type, params, evnt) {
                emit(type, Object.assign({ $radio: $xeradio, $event: evnt }, params));
            }
        };
        Object.assign($xeradio, radioMethods);
        var renderVN = function () {
            var _a;
            var vSize = computeSize.value;
            var isDisabled = computeDisabled.value;
            var name = computeName.value;
            var isChecked = computeChecked.value;
            return h('label', {
                class: ['vxe-radio', (_a = {},
                        _a["size--".concat(vSize)] = vSize,
                        _a['is--checked'] = isChecked,
                        _a['is--disabled'] = isDisabled,
                        _a)],
                title: props.title
            }, [
                h('input', {
                    class: 'vxe-radio--input',
                    type: 'radio',
                    name: name,
                    checked: isChecked,
                    disabled: isDisabled,
                    onChange: changeEvent,
                    onClick: clickEvent
                }),
                h('span', {
                    class: ['vxe-radio--icon', isChecked ? 'vxe-icon-radio-checked' : 'vxe-icon-radio-unchecked']
                }),
                h('span', {
                    class: 'vxe-radio--label'
                }, slots.default ? slots.default({}) : getFuncText(props.content))
            ]);
        };
        $xeradio.renderVN = renderVN;
        return $xeradio;
    },
    render: function () {
        return this.renderVN();
    }
});
